import { useContext } from 'react';

import { AuthContext } from 'state/auth';

export default function useAuth() {
  return useContext(AuthContext);
}
